import type { IconData } from '@stacksjs/iconify-core'

export const star: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17.562 21.56a1 1 0 0 1-.465-.115L12 18.765l-5.097 2.68a1 1 0 0 1-1.451-1.054l.973-5.676l-4.123-4.02a1 1 0 0 1 .554-1.705l5.699-.828l2.548-5.164a1.042 1.042 0 0 1 1.794 0l2.548 5.164l5.699.828a1 1 0 0 1 .554 1.706l-4.123 4.019l.973 5.676a1 1 0 0 1-.986 1.169\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default star
